import {
  AlertTriangle,
  Clock,
  RotateCcw,
  XCircle,
  Receipt,
} from 'lucide-react';
import {
  AttentionCard,
  SectionHeader,
} from '@/components/dashboard/DashboardCards';
import {
  ATTENTION_METRICS,
  formatCount,
  statCount,
} from '@/components/dashboard/commandCenterConfig';
import type { AttentionMetricKey, OrderStatistics } from '@/types/dashboard';
import type { ReactNode } from 'react';

const ATTENTION_ICONS: Record<AttentionMetricKey, ReactNode> = {
  searching_for_dm: <Clock size={22} strokeWidth={1.85} />,
  payment_failed: <AlertTriangle size={22} strokeWidth={1.85} />,
  refund_requested: <Receipt size={22} strokeWidth={1.85} />,
  refunded: <RotateCcw size={22} strokeWidth={1.85} />,
  canceled: <XCircle size={22} strokeWidth={1.85} />,
};

export function NeedsAttention({
  stats,
  loading,
}: {
  stats: OrderStatistics | undefined;
  loading: boolean;
}) {
  return (
    <section className="cmd-section" aria-label="Needs attention">
      <SectionHeader
        title="Needs Attention"
      />
      <div className="attention-grid">
        {ATTENTION_METRICS.map((metric) => (
          <AttentionCard
            key={metric.key}
            icon={ATTENTION_ICONS[metric.key]}
            label={metric.label}
            value={formatCount(statCount(stats, metric.key))}
            description={metric.description}
            tone={metric.tone}
            to={metric.href}
            search={metric.search}
            loading={loading}
          />
        ))}
      </div>
    </section>
  );
}
